import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { GridApi } from "ag-grid-community";
import { IstSummaryService } from "src/app/services/ist/ist-summary.service";
import { DeleteBoxComponent } from "src/app/common/delete-box/delete-box.component";
import { IstDataShareService } from '../../../services/ist/ist-datashare.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from '../../../services/common.service';
import { UserService } from '../../../services/user.service';
import { EapAmendmentsViewModalComponent } from './eap-amendments-view-modal/eap-amendments-view-modal.component';
import {  NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EAPDatashareService } from "src/app/services/eap/eap-datashare.service";
@Component({
  selector: "app-eap-amendments",
  templateUrl: "./eap-amendments.component.html",
  styleUrls: ["./eap-amendments.component.scss"]
})
export class EapAmendmentsComponent implements OnInit {
 columnDefs;
   operations;
   tempoperations;
   gridApi: GridApi;
   selectedRow;
   rowData;
   staticformFields: any;
   ApplicationID: string;
   Statuslist: any = [];
   amendmentsSearchform: UntypedFormGroup;
   permission: string = "";
   userType: string = "";
   type;
   IsScreenGrid = true;
   collapesedOrNot: boolean = false;
   screenName: string = "";
   constructor(
     public route: ActivatedRoute,
     private summaryService: IstSummaryService,
     private modalService: NgbModal,
     private datashareService: EAPDatashareService,
     private commonService: CommonService,
     private userService: UserService
   ) { }
 
   ngOnInit() {
 
     this.permission = this.commonService.getPagePermission("EAP08").toLowerCase();
 
     if (this.permission == null || this.permission == undefined || this.permission == '') {
       const intervalId = setInterval(() => {
         this.permission = this.commonService.getPagePermission("EAP08").toLowerCase();
         if (this.permission != null && this.permission != undefined && this.permission != '') {
             this.setOperations(this.rowData);
           clearInterval(intervalId);
         }
       }, 1000);
     }
 
     this.datashareService.ApplicationID.subscribe(x => {
       this.ApplicationID = x;
     });
     this.getStaticFiledsData('SCR-021');
     this.GetScreenConfigControls('SCR-021');
     this.userType = this.userService.getUserType();
     this.Statuslist.push({ label: "All", value: "-1", checked: true });
     this.Statuslist.push({ label: "Submitted", value: "Submitted" });
     this.Statuslist.push({ label: "Draft", value: "Draft" });
 
     this.amendmentsSearchform = new UntypedFormGroup({
       Type: new UntypedFormControl(null),
       Title: new UntypedFormControl(null),
       Status: new UntypedFormControl(null),
     });
 
 
     this.tempoperations = [
     ];
 
     this.getTypes();
     this.setSummary();
   }
 
   getStaticFiledsData(screenCode: string) {
     this.commonService.getScreenStaticFields(screenCode, this.ApplicationID)
       .subscribe(summary => {
         this.staticformFields = summary["Data"];
         if (this.userType == "E") {
           this.columnDefs = [
             {
               "headerName": this.staticformFields?.TYPE.LABEL_NAME,
               "field": "Type"
             },
             {
               "headerName": this.staticformFields?.TITLE.LABEL_NAME,
               "field": "Title"
             },
             {
               "headerName": "Status",
               "field": "Status"
             },
             {
               "headerName": "Submitted Date",
               "field": "SubmittedDateStr"
             }
           ];
         } else {
           this.columnDefs = [
             {
               "headerName": this.staticformFields?.TYPE.LABEL_NAME,
               "field": "Type"
             },
             {
               "headerName": this.staticformFields?.TITLE.LABEL_NAME,
               "field": "Title"
             },
             {
               "headerName": "Submitted Date",
               "field": "SubmittedDateStr"
             }
           ];
         }
       });
   }
 
   onSetGridApi(gridApi) {
     this.gridApi = gridApi;
   }
 
   onCallbackOperation(opr) {
     opr.callback(this.summaryService);
   }
 
   onSelectionChanged(event) {
     this.selectedRow = this.gridApi.getSelectedRows()
       ? this.gridApi.getSelectedRows()[0]
       : null;
   }
 
   onRowDoubleClicked(event) {
     const modelRef = this.modalService.open(EapAmendmentsViewModalComponent, {
       backdrop: false,
       keyboard: false,
       windowClass: "modal-vlg modal-full-height modal-right",
       animation: true
     });
     modelRef.componentInstance.Content = {
       heading: "View",
       content: { id: event.data['ID'], ApplicationID: this.ApplicationID }
     }
   }
 
   add() {
     let modalRef = this.modalService.open(
       EapAmendmentsViewModalComponent,
       {
         backdrop: false,
         keyboard: false,
         windowClass: "modal-vlg right modal-right",
         animation: true,
       });
     modalRef.componentInstance.Content = {
       heading: "Add",
       content: { id: "", ApplicationID: this.ApplicationID }
     }
 
     modalRef.result.then(result => {
       if (result) {
         this.setSummary();
       }
     });
   }
 
   edit(RcordData: any) {
     let hedingText = "Edit";
     if (this['self'].selectedRow["SubmittedDateStr"] != undefined && this['self'].selectedRow["SubmittedDateStr"] != "" && this['self'].selectedRow["SubmittedDateStr"] != null) {
       hedingText = "View";
     }
     let modalRef = this['self'].modalService.open(EapAmendmentsViewModalComponent, {
       backdrop: false,
       keyboard: false,
       windowClass: 'modal-vlg right modal-right',
       animation: true,
     });
 
     modalRef.componentInstance.Content = {
       heading: hedingText,
       content: { id: RcordData['ID'], ApplicationID: this.ApplicationID, selectedData: RcordData }
     }
     modalRef.result.then(result => {
       if (result) {
         this['self'].setSummary();
       }
     })
   }
 
   view(RcordData: any) {
     let hedingText = "View";
     let modalRef = this['self'].modalService.open(EapAmendmentsViewModalComponent, {
       backdrop: false,
       keyboard: false,
       windowClass: 'modal-vlg right modal-right',
       animation: true,
     });
     modalRef.componentInstance.Content = {
       heading: hedingText,
       content: { id: RcordData['ID'], ApplicationID: this.ApplicationID }
 
     }
   }
 
   delete(RcordData: any) {
     let id = RcordData['ID'];
     let Title = RcordData['Title'];
     let modalRef = this["self"].modalService.open(DeleteBoxComponent, { backdrop: false });
     modalRef.componentInstance.Content = { heading: '', custommessage: 'Are you sure you want to delete ' + '?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" };
     modalRef.result.then(result => {
       if (result == "okclick") {
         this['self'].summaryService.DeleteRecord('api/EAPAmendments/Delete?RecordID=' + id).subscribe(summary => {
           if (summary.Status == 0) {
             this['self'].setSummary();
             this['self'].commonService.SuccessBanner(this['self'].screenName + " deleted successfully");
           } else {
             this.commonService.ErrorBanner(result.Message);
           }
         });
       }
     });
   }
 
   setSummary() {
     this.SearchClear();
     this.summaryService.getSummaryData("api/EAPAmendments/getSummaryData?ApplicationID=" + this.ApplicationID).subscribe((summary: any) => {
       for (let i = 0; summary.length > i; i++) {
         summary[i]["Status"] = summary[i]["Status"] == 2 ? "Submitted" : "Draft";
 
       }
       this.rowData = this.setOperations(summary);
     });
   }
 
   setOperations(RawData: any): any {
 
     if (this.permission == "new") {
       this.tempoperations = [
         {
           "name": "Edit",
           "id": "edit"
         },
         {
           "name": "Delete",
           "id": "delete"
         },
         {
           "name": "View",
           "id": "view"
         },
         {
           "name": "Add ",
           "id": "add"
         }
       ];
     }
 
     if (this.permission == "edit") {
       this.tempoperations = [
         {
           "name": "Edit",
           "id": "edit"
         },
         {
           "name": "Delete",
           "id": "delete"
         },
         {
           "name": "View",
           "id": "view"
         }
       ];
     }
 
 
     this.setDef(this.tempoperations);
     RawData.forEach(element => {
       if (element.Status == "Submitted") {
         let tempoperations2 = [
           {
             "name": "View",
             "id": "view"
           }
         ];
         if (this.permission == "new") {
           tempoperations2.push({
             "name": "Add " + this.screenName,
             "id": "add"
           })
         }
         element["Operations"] = this.setDef(tempoperations2);
       }
 
       if (element.Status == "Draft") {
         element["Operations"] = this.setDef(this.tempoperations);
       }
 
       if (this.permission == "view") {
         this.tempoperations = [
           {
             "name": "View",
             "id": "view"
           }
         ];
 
         element["Operations"] = this.setDef(this.tempoperations);
       }
     });
 
     setTimeout(() => {
       this.gridApi.sizeColumnsToFit();
     }, 500);
     return RawData;
   }
 
   setDef(parmoperations: any): any {
     this.operations = parmoperations.map(operation => {
       return operation &&
         (operation.id === "add" || operation.id === "view_modal")
         ? {
           name: operation.name,
           callback: this[operation.id],
           self: this,
           disabled: "false"
         }
         : { name: operation.name, callback: this[operation.id], self: this };
     });
     return this.operations;
   }
 
   getSearchSummary(searchObject) {
     this.summaryService.fetchSearchData("api/EAPAmendments/getSummarySearchData", searchObject).subscribe((summary: any) => {
       for (let i = 0; summary.length > i; i++) {
         summary[i]["Status"] = summary[i]["Status"] == 2 ? "Submitted" : "Draft";
 
       }
       this.rowData = summary;
     });
   }
 
   getTypes() {
     this.summaryService.getSummaryData("api/EAPAmendments/getTypes?ApplicationID=" + this.ApplicationID).subscribe(summary => {
       this.type = summary;
       this.type = [{ label: "All", value: "", checked: true }].concat(this.type);
     });
   }
 
   SearchClear() {
     this.amendmentsSearchform.reset();
   }
 
   AdvanceSearch() {
     var formData = this.amendmentsSearchform.value;
     formData["ApplicationID"] = this.ApplicationID;
     this.getSearchSummary(formData);
   }
 
   GetScreenConfigControls(screenCode: string) {
     this.commonService.GetScreenConfigControls(screenCode, this.ApplicationID, '', (ScreenData) => {
       this.screenName = ScreenData.NAME;
       this.setSummary();
     });
   }
 }
 